module.exports = __webpack_public_path__ + "static/media/landing-hero.7319feb4.jpg";